import { TEST_IDS } from '../../constants/testIds';

/**
 * ProgressRing — SVG circular progress with gradient stroke.
 * @param {{ value: number, size?: number, strokeWidth?: number, label?: string, className?: string }} props
 */
export default function ProgressRing({ value = 0, size = 120, strokeWidth = 8, label, className = '' }) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (value / 100) * circumference;
  const gradId = `pr-grad-${size}-${label || 'default'}`;

  return (
    <div data-testid={TEST_IDS.PROGRESS_RING} className={`relative inline-flex items-center justify-center ${className}`}>
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#5B2D9E" />
            <stop offset="100%" stopColor="#3D1F6E" />
          </linearGradient>
        </defs>
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none"
          stroke="hsl(var(--border))"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none"
          stroke={`url(#${gradId})`}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 0.6s ease' }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-xl font-bold tracking-tight font-heading">
          {Math.round(value)}%
        </span>
        {label && <span className="text-[10px] text-muted-foreground font-medium mt-0.5">{label}</span>}
      </div>
    </div>
  );
}
